module.exports = " <div class=d-video> <video v-on:mouseover=start v-on:mouseout=stop height=180 v-bind:src=video.url v-bind:poster=video.img> </video> <i class=\"fa fa-file-video-o fa-2x\"></i> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/8.5.3/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoShow.vue
 ** module id = 75
 ** module chunks = 0
 **/